<ng-http-loader [debounceDelay]="600" spinner="sk-three-bounce" [filteredUrlPatterns]="['.*generate_recommendations.*']" [filteredHeaders]="['Accept']"></ng-http-loader>
<app-header (snackBarEvent)="onSnackBar()"></app-header>
<app-survey></app-survey>
<div class="container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>